import InvitationTable from './invitationTable';

const InvitationBody = () => {
    interface InvitationType {
        invitation: string;
        email: string,
        date: string,
        reference: string,
        status: string,
    }
    const tdata:InvitationType[] = [{
      invitation: 'Network', reference: 'My Net', email: 'dev@gmail.com', date: '13/12/2021', status: 'Pending',
    },
    {
      invitation: 'Network', reference: 'Network A', email: 'test1@gmail.com', date: '13/12/2021', status: 'Accepted',
    },
    {
      invitation: 'Network', reference: 'Network B', email: 'dev2@gmail.com', date: '13/12/2021', status: 'Cancelled',
    },
    {
      invitation: 'Network', reference: 'Network C', email: 'zeeve@gmail.com', date: '13/12/2021', status: 'Rejected',
    },
    ];

    return (
        <section className="px-5 col-12 workspace">
            <div className=" mt-3">
                <div className="row">
                    <div className="col-lg-6 col-xl-6 col-sm-12 col-xs-12 cursor">
                        <h5 className="mt-2 all-color">Invitation Manager</h5>
                    </div>
                </div>
                <h6 className="text-center mt-5 mb-5">Invitations Received</h6>
                <InvitationTable entires={tdata} type="received" />
                <h6 className="text-center mt-5 mb-5">Invitations Sent</h6>
                <InvitationTable entires={tdata} type="Sent" />
            </div>
        </section>
    );
};
export default InvitationBody;